// Module
var code = `<div class="global-loading flex items-center justify-center"> <bds-illustration type="brand" name="blip-ballon-white" class="pulse-large animated duration-1-5s infinite"> </bds-illustration> </div> `;
// Exports
module.exports = code;